import type { NewCoreIconProps } from '@atlaskit/icon';

import {
	FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP,
	FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP,
	FOCUS_AREA_HEALTH_KEYS_LIST,
	FOCUS_AREA_STATUS_KEYS,
	FOCUS_AREA_STATUS_KEYS_LIST,
	type FocusAreaDerivedStatusKey,
	type FocusAreaDerivedStatusLabel,
	type FocusAreaHealthKey,
	type FocusAreaStatusKey,
} from './types';

export const getFocusAreaIconColor = ({
	customColor,
	status,
	health,
}: {
	customColor?: NewCoreIconProps['color'];
	status?: FocusAreaStatusKey | undefined;
	health?: FocusAreaHealthKey | undefined;
}): NewCoreIconProps['color'] =>
	customColor ||
	FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP[getDerivedStatus({ status, health }).derivedStatusKey];

export const getDerivedStatus = ({
	status,
	health,
}: {
	status?: FocusAreaStatusKey | undefined;
	health?: FocusAreaHealthKey | undefined;
}): {
	derivedStatusKey: FocusAreaDerivedStatusKey;
	derivedStatusLabel: FocusAreaDerivedStatusLabel;
} => {
	const statusKey = getValidStatus(status);
	const healthKey = getValidHealth(health);

	const derivedStatusKey =
		statusKey === FOCUS_AREA_STATUS_KEYS.IN_PROGRESS && healthKey ? healthKey : statusKey;

	return {
		derivedStatusKey: derivedStatusKey,
		derivedStatusLabel: FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP[derivedStatusKey],
	};
};

const getValidStatus = (status?: FocusAreaStatusKey | undefined): FocusAreaStatusKey =>
	status && FOCUS_AREA_STATUS_KEYS_LIST.includes(status) ? status : FOCUS_AREA_STATUS_KEYS.PENDING;

const getValidHealth = (health?: FocusAreaHealthKey | undefined): FocusAreaHealthKey | undefined =>
	health && FOCUS_AREA_HEALTH_KEYS_LIST.includes(health) ? health : undefined;
